import { render, staticRenderFns } from "./settingsCategoryIcon.vue?vue&type=template&id=b02f78c6&scoped=true"
import script from "./settingsCategoryIcon.vue?vue&type=script&lang=js"
export * from "./settingsCategoryIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b02f78c6",
  null
  
)

export default component.exports